module.exports = __webpack_public_path__ + "static/media/RV.80db5edf.png";